import { useAppSelector } from "@/store/store-hooks";
import { selectProjectName } from "@faro-lotv/app-component-toolbox";
import { FaroBreadcrumbs } from "@faro-lotv/flat-ui";
import { type JSX } from "react";

type ToolBreadcrumbsProps = {
  /** The name of the tool to display in the breadcrumbs. */
  toolName: string;

  /** A callback that is called when the user tries to redirect back to the viewer */
  onRedirectToViewerClicked?(): void;
};

/**
 * @returns The breadcrumbs for a tool in the Sphere Viewer.
 * Displays the project name and the name of the tool.
 * Clicking on the project name executes the callback to redirect the user back to the main page.
 */
export function ToolBreadcrumbs({
  toolName,
  onRedirectToViewerClicked,
}: ToolBreadcrumbsProps): JSX.Element {
  const projectName = useAppSelector(selectProjectName);

  return (
    <FaroBreadcrumbs
      // The link only shows the URL; the click asks for confirmation before redirecting.
      breadcrumbs={[
        { text: projectName ?? "", link: "/", shouldNotTranslate: true },
        { text: toolName },
      ]}
      onBreadcrumbClick={(breadcrumb) => {
        if (breadcrumb.link) onRedirectToViewerClicked?.();
      }}
      maxWidth="330px"
    />
  );
}
